import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {debounce} from 'lodash';
import {generateUUID} from 'src/utils/page-site';

import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';
import {Card} from '@spaced-out/ui-design-system/lib/components/Card';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import classify from 'src/utils/classify';

import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import {
  RadioButton,
  RadioGroup,
} from '@spaced-out/ui-design-system/lib/components/RadioButton';

import {
  SubTitleSmall,
  SubTitleMedium,
  BodySmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';

import css from './evaluation-scorecard-edit.css';


const EvaluationScorecardEdit = ({
  // @ts-expect-error - TS7031 - Binding element 'scorecardStepSections' implicitly has an 'any' type.
  scorecardStepSections,
  // @ts-expect-error - TS7031 - Binding element 'feedbackScores' implicitly has an 'any' type.
  feedbackScores,
  // @ts-expect-error - TS7031 - Binding element 'feedbackConfiguration' implicitly has an 'any' type.
  feedbackConfiguration,
  // @ts-expect-error - TS7031 - Binding element 'handleScorecardOnChange' implicitly has an 'any' type.
  handleScorecardOnChange,
  // @ts-expect-error - TS7031 - Binding element 'handleRemarkChange' implicitly has an 'any' type.
  handleRemarkChange,
  // @ts-expect-error - TS7031 - Binding element 'noShow' implicitly has an 'any' type.
  noShow,
}) => {
  const {t} = useLabelTranslation();

  const {ratingNames} = feedbackConfiguration || {};
  const [openCommentIds, setOpenCommentIds] = React.useState(new Set());

  // @ts-expect-error - TS7006 - Parameter 'feedbackScore' implicitly has an 'any' type.
  const parmeterScoresAndRemarks = feedbackScores.map((feedbackScore) => {
    const {parameterId, score, remark} = feedbackScore;
    return {
      parameterId,
      score,
      remark,
    };
  });
  const ratingNamesList = ratingNames?.split(',') || [];

  if (
    Array.isArray(scorecardStepSections) &&
    scorecardStepSections.length === 0
  ) {
    return null;
  }

  // Toggle comment textarea for a specific parameter
  const toggleCommentTextarea = (parameterId: any) => {
    setOpenCommentIds((prevOpenIds) => {
      const newOpenIds = new Set(prevOpenIds);
      if (newOpenIds.has(parameterId)) {
        newOpenIds.delete(parameterId);
      } else {
        newOpenIds.add(parameterId);
      }
      return newOpenIds;
    });
  };

  const handleRatingChange = (parameterId: any, value: number) => {
    handleScorecardOnChange({
      type: 'RATING',
      parameterId,
      score: value,
    });
  };

  return (
    <div className={css.column}>
      <div className={css.scorecardTitle}>
        <SubTitleMedium>{t('Scorecard', 'Scorecard')}</SubTitleMedium>
        <Tooltip
          elevation="modal"
          titleMaxLines={4}
          title={`${t(
            'Reviewer_scores_are_based_on_a',
            'Reviewer scores are based on a',
          )} ${ratingNamesList.length}-${t(
            'point_scale_adjustable_by_the_Admin_in_the_organization\'s_Settings',
            'point scale, adjustable by the Admin in the organization\'s Settings',
          )}.`}
        >
          <Icon name="info-circle" size="small" />
        </Tooltip>
      </div>
      {scorecardStepSections?.map((section: any) => (
        <Card classNames={{wrapper: css.scoreCardWrapper}}>
          <SubTitleSmall>{section.name || ''}</SubTitleSmall>
          {/* @ts-expect-error - TS7006 - Parameter 'parameter' implicitly has an 'any' type. */}
          {section.parameters.map((parameter) => {
            return (
              <div className={css.starContainer}>
                <div className={css.ratingItem}>
                  <div className={css.starContainerText}>
                    <BodySmall color="tertiary">
                      {parameter.name || ''}
                    </BodySmall>

                    {parameter.description && (
                      <Tooltip
                        elevation="modal"
                        title={parameter.description || ''}
                        titleMaxLines={4}
                      >
                        <Icon
                          name="square-question"
                          size="small"
                          type="regular"
                        />
                      </Tooltip>
                    )}
                  </div>
                  <div className={css.ratingWrapper}>
                    <div className={css.starContainerStars}>
                      <RadioGroup
                        name={`parameter_${parameter.id}`}
                        value={
                          feedbackScores.find(
                            // @ts-expect-error - TS7006 - Parameter 'score' implicitly has an 'any' type.
                            (score) => score.parameterId === parameter.id,
                          )?.score || ''
                        }
                        align="horizontal-fluid"
                        onChange={(value) =>
                          handleRatingChange(parameter.id, parseInt(value, 10))
                        }
                      >
                        {Array(feedbackConfiguration?.ratingScale)
                          // @ts-expect-error - TS2554 - Expected 1-3 arguments, but got 0.
                          .fill()
                          .map((_, index) => (
                            <RadioButton
                              key={generateUUID()}
                              disabled={noShow}
                              // @ts-expect-error - TS2769 - No overload matches this call.
                              value={index + 1}
                            >
                              {index + 1}
                            </RadioButton>
                          ))}
                      </RadioGroup>
                      <Tooltip
                        elevation="modal"
                        title={
                          feedbackScores.find(
                            // @ts-expect-error - TS7006 - Parameter 'score' implicitly has an 'any' type.
                            (score) => score.parameterId === parameter.id,
                          )?.remark
                            ? t('Edit_Comment', 'Edit Comment')
                            : t('Add_Comment', 'Add Comment')
                        }
                      >
                        <Button
                          onClick={() => toggleCommentTextarea(parameter.id)}
                          iconRightName={
                            feedbackScores.find(
                              // @ts-expect-error - TS7006 - Parameter 'score' implicitly has an 'any' type.
                              (score) => score.parameterId === parameter.id,
                            )?.remark
                              ? 'comment-pen'
                              : 'comment'
                          }
                          disabled={noShow}
                          classNames={{
                            icon: classify({
                              [css.remarkButton]: feedbackScores.find(
                                // @ts-expect-error - TS7006 - Parameter 'score' implicitly has an 'any' type.
                                (score) => score.parameterId === parameter.id,
                              )?.remark,
                            }),
                          }}
                          type="ghost"
                          size="small"
                        />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {openCommentIds.has(parameter.id) ? (
                  <Textarea
                    placeholder={t('Add_Remark', 'Add Remark')}
                    size="medium"
                    classNames={{box: css.textArea}}
                    value={
                      feedbackScores.find(
                        // @ts-expect-error - TS7006 - Parameter 'score' implicitly has an 'any' type.
                        (score) => score.parameterId === parameter.id,
                      )?.remark || ''
                    }
                    onChange={(e) => {
                      handleRemarkChange(parameter.id, e.target.value);
                    }}
                    disabled={noShow}
                  />
                ) : null}
              </div>
            );
          })}
        </Card>
      ))}
    </div>
  );
};

export default EvaluationScorecardEdit;
